export const splitEmails = (s) =>
  (s || "")
    .split(/[,;\s]+/)
    .map((t) => t.trim())
    .filter(Boolean);

export const isEmail = (s) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || "").trim());

export const normalizeEmailCsv = (csv) => {
  const uniq = new Set();

  splitEmails(csv)
    .map((x) => String(x || "").trim().toLowerCase())
    .filter((x) => x && isEmail(x))
    .forEach((x) => uniq.add(x));

  return Array.from(uniq).sort().join(",");
};


export const sameEmailSet = (a, b) => normalizeEmailCsv(a) === normalizeEmailCsv(b);

export const formatEmails = (v) =>
  v
    ? String(v)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .join(", ")
    : "";

/**
 * Costruisce CSV "default" da un payload defaults (docs/contract recipients default)
 * Supporta sia:
 * - send_company / company_email
 * - send_handlers / handlers_emails[]
 * - others_emails (CSV string)
 */
export const buildDefaultEmailCsv = ({
  send_company,
  company_email,
  send_handlers,
  handlers_emails,
  others_emails,
}) => {
  const acc = [];

  if (send_company && company_email) acc.push(company_email);

  if (send_handlers && Array.isArray(handlers_emails)) {
    handlers_emails.forEach((h) => {
      if (h?.email) acc.push(h.email);
    });
  }

  if (others_emails) acc.push(others_emails); // può essere già CSV -> normalize gestisce

  return normalizeEmailCsv(acc.join(","));
};
